import Vue from 'vue';
import App from '@/js/views/App';
import router from './js/router';

import './js/bootstrap';

Vue.config.productionTip = false;

const data = {
  cart: null,
};

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  data,
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js